module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_1@2x.99b0f4a5.png";